export enum ThirdPartyType {
  None = 0,
  Facebook = 1,
  LinkedIn = 2,
  ESOT = 4,
  Orcid = 5,
  Twitter = 6
}
